import { Overlay } from 'primeng/overlay'

import { checkIsElementAttached } from '../../layout/utils'

export function patchOverlay() {
  /**
   * Patch the OverlayPanel hide method to fix stale overlays due to custom route reuse
   *
   * PrimeNG overlays attach their content to a separate part of the DOM (outside the Angular component tree)
   * When using a custom route reuse strategy, the normal component destruction does not occur,
   * so the overlay may remain visible in the DOM even though its component is detached
   */
  const orig__Overlay_hide = Overlay.prototype.hide
  Overlay.prototype.hide = function (...args) {
    orig__Overlay_hide.call(this, ...args)

    setTimeout(() => {
      if (!checkIsElementAttached(this.el.nativeElement)) {
        this.cd.detectChanges()
      }
    }, 32)
  }
}
